import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";

import ComplaintList from "../pages/Residential/Phase-03/Complaint/ComplaintList";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
    fetchComplaintForms,
    deleteComplaintForm,
} from "../store/slices/complaintFormSlice";

const Complaint = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Redux state
    const { complaintForms, isLoading } = useSelector(
    (state) => state.complaintForm
);

    // Fetch records on mount
    useEffect(() => {
        dispatch(fetchComplaintForms());
    }, [dispatch]);

    const handleAdd = () => navigate("/phase03/complaint-form/add");

    const handleEdit = (id) => {
        navigate(`/phase03/complaint-form/edit/${id}`);
    };

    const handleDelete = async (id) => {
        await dispatch(deleteComplaintForm(id));
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <ComplaintList
                            records={complaintForms}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default Complaint;
